<template>
  <AppHeaderDropdown right class="mr-2 user-dropdown">
    <template slot="header">
      <img :src="avatar_url" class="img-avatar" />
    </template>
    <template slot="dropdown">
      <div class="user-dropdown__header">
        <img :src="avatar_url" class="user-dropdown__avatar" />
        <div class="user-dropdown__meta">
          <div class="user-dropdown__label">Signed in as</div>
          <strong class="user-dropdown__name">{{ current_user.username || "User" }}</strong>
        </div>
      </div>
      <b-dropdown-item to="/servers">
        <i class="icon-list" />Servers
      </b-dropdown-item>
      <b-dropdown-item to="/premium">
        <i class="icon-layers" />Premium
      </b-dropdown-item>
      <b-dropdown-item to="/status">
        <i class="fa fa-heartbeat" />Status
      </b-dropdown-item>
      <b-dropdown-item @click="logout">
        <i class="icon-logout" />Log out
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown,
  },
  data: () => {
    return {};
  },
  methods: {
    logout() {
      localStorage.removeItem("sidebar-collapse-state");
      this.axios.get("/api/logout").then(this.$router.push("/"));
      this.$store.commit("logout");
    },
  },
  computed: {
    current_user() {
      return this.$store.state.discord_user || {};
    },
    avatar_url() {
      if (this.current_user.avatar === null) {
        return "https://discordapp.com/assets/1cbd08c76f8af6dddce02c5138971129.png";
      }
      return `https://cdn.discordapp.com/avatars/${this.current_user.id}/${this.current_user.avatar}.png?size=64`;
    },
    current_guild() {
      return this.$store.state.discord_guilds.find(
        (x) => x.id == this.$route.params.guild_id
      );
    },
  },
};
</script>

<style>
.user-dropdown .dropdown-menu {
  min-width: 220px;
  padding-top: 0;
}
.user-dropdown__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(158, 128, 255, 0.12);
  border-left: 3px solid #9e80ff;
  cursor: default;
}
.user-dropdown__avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
}
.user-dropdown__meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
}
.user-dropdown__label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #9e80ff;
  margin-bottom: 1px;
}
.user-dropdown__name {
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
